
import { Options, Vue } from 'vue-property-decorator'

@Options({
  name: 'SliderLeft'
})
export default class SliderLeft extends Vue {}
